import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  TextField,
  Box,
  IconButton,
  AppBar,
  Toolbar,
  Card,
  CardContent,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  List,
  CircularProgress,
  Button,
  Modal,
  Checkbox,
} from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { apiUrl } from '../../config';
import apiFaculty from '../../utlis/apiFaculty';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  width: '60vw',
  maxHeight: '90vh', 
  overflowY: 'scroll',
};

const AttendanceTable = () => {
  const navigate = useNavigate();
  const pageOption = [10, 25, 50, 100];
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 50,
    page: 0,
  });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalResults, setTotalResults] = useState(0);
  const [attendanceModal, setAttendanceModal] = useState(false);
  const [students, setStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [attendanceId, setAttendanceId] = useState('');
  const [scheduleId, setScheduleId] = useState('');

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {

      const response = await apiFaculty.get(`${apiUrl}/admin/faculty/schedule`, {
        params: {
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
        },
        headers: {
          'Content-Type': 'application/json',
        },
      });

      setData(response?.data?.schedules || []);
      setTotalResults(response?.data?.totalResults);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const markAttendance = async (id) => {
    setAttendanceModal(true);
    setScheduleId(id);
    try {
      const response = await apiFaculty.get(`${apiUrl}/admin/faculty/get/schedule/student`, {
        params: {
          id: id,
        },
        headers: {
          'Content-Type': 'application/json',
        },
      });

      setStudents(response?.data?.attendance?.students);
      setAttendanceId(response?.data?.attendance?._id);
    } catch (error) {
      alert(error?.response?.data?.error);
      console.error(error);
    }
  }

  const filteredStudents = students.filter((student) =>
    (student?.student?.firstName.toLowerCase().includes(searchTerm.toLowerCase()) || 
    student?.student?.lastName.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const handleCheckboxChange = (id) => {
    setStudents((prevStudents) => {
      const updatedStudents = prevStudents.map(student => {
        if (student._id === id) {
          return {
            ...student,
            status: student.status === 'present' ? 'absent' : 'present',
            currentUpdate: true,
          };
        }
        return student;
      });
      return updatedStudents;
    });
  };

  const handleRemarksChange = (id, value) => {
    setStudents((prevStudents) => {
      const updatedStudents = prevStudents.map(student => {
        if (student._id === id) {
          return {
            ...student,
            remarks: value
          };
        }
        return student;
      });
      return updatedStudents;
    });
  };

  const updateAttendance = async (e, type) => {
    e.preventDefault();
    let murl = `${apiUrl}/admin/faculty/update/student/attendance?id=${attendanceId}`;
    try {
      const response = await apiFaculty.post(murl, { students: students, scheduleId: scheduleId }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      alert('Attendance recorded!');
    } catch (error) {
      alert(error?.response?.data?.error);
      console.error(error);
    }
  }

  return (
    <Container maxWidth={'100%'} sx={{ paddingLeft: 0 }} style={{ padding: 0 }}>
      <AppBar position="static" sx={{ marginBottom: 2 }}>
        <Toolbar>
          <IconButton size="large" edge="start" color="inherit" onClick={handleBack} sx={{ mr: 2 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" component="div">
            ATTENDANCE
          </Typography>
        </Toolbar>
      </AppBar>
      <Container component="main" sx={{ flexGrow: 1, p: 3, overflowX: 'hidden' }} maxWidth={false}>
        {loading ? ( // Show loader if loading
          <CircularProgress style={{ margin: '20px auto', display: 'block' }} />
        ) : (
          <div style={{ height: 400, width: '100%' }}>
              <DataGridPro
                  rows={data}
                  getRowId={(row) => row._id}
                  columns={[
                      { field: 'batch', headerName: 'Batch', flex: 1, valueGetter: (params) => params.row?.batch?.name },
                      { field: 'date', headerName: 'Date', flex: 1, valueFormatter: (params) => new Date(params.value).toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' }) },
                      { field: 'status', headerName: 'Status', flex: 1, valueGetter: (params) => params.row?.status === 'active' ? 'Active' : params.row?.status === 'completed' ? 'Completed' : 'Canceled' },
                      {
                          field: 'actions',
                          headerName: 'Action',
                          flex: 1,
                          renderCell: (params) => (
                            <Button variant="outlined" onClick={() => markAttendance(params.row?._id)}>Mark Attendance</Button>
                          ),
                      },
                  ]}
                  pagination
                  paginationModel={paginationModel}
                  rowCount={totalResults}
                  paginationMode="server"
                  onPaginationModelChange={setPaginationModel}
                  pageSizeOptions={pageOption} 
              />
          </div>
        )}
        <Modal
          open={attendanceModal}
          onClose={() => setAttendanceModal(false)}
          aria-labelledby="modal-title"
        >
          <Box sx={{ ...style }}>
            <Typography variant="h5" gutterBottom>
              Student List  | Total : {students?.length} | Absent : {students.filter(student => student.status === 'absent')?.length} | Present {students.filter(student => student.status === 'present')?.length}
            </Typography>
            <TextField
              label="Search"
              variant="outlined"
              fullWidth
              margin="normal"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              size="small"
            />
            <List style={{marginTop:10,marginBottom:20}}>
              {filteredStudents.map((student, index) => (
                <Card key={student?._id} sx={{ marginBottom: 2,padding:0,paddingBottom:0  }} >
                  <CardContent >
                    <ListItem>
                      <ListItemText
                        primary={
                          <Typography
                            sx={{
                              textDecoration: student.status == 'present'? 'none' : 'line-through',
                              color: student.status== 'present' ? 'inherit' : 'red',
                            }}
                          >
                            {`${student?.student?.firstName} ${student?.student?.lastName}`}
                          </Typography>
                        }
                      />
                      <ListItemSecondaryAction>
                        {student?.status == 'absent' ? (
                          <TextField
                            label="Remarks"
                            style={{ padding: 0 }}
                            value={student?.remarks}
                            onChange={(e) => handleRemarksChange(student?._id, e.target.value)}
                            size="small"
                          />
                        ) : student?.remarks !== '' ? 
                          student?.remarks
                        :''}
                        <Checkbox
                          checked={student?.status == 'present'}
                          onChange={() => handleCheckboxChange(student?._id)}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  </CardContent>
                </Card>
              ))}

              <Button type="button" onClick={() => setAttendanceModal(false)} variant="outlined" color="primary" style={{ marginTop: '20px', marginRight: '10px' }}>Cancel</Button>
              <Button type="button" onClick={(e) => updateAttendance(e, '')} variant="contained" color="primary" style={{ marginTop: '20px' }}>Update Attendance</Button>
            </List>
          </Box>
        </Modal>
      </Container>
    </Container>
  );
};

export default AttendanceTable;
